export default "__VITE_ASSET__D6aj2_5O__"